import MuiToggleButtonGroup, { ToggleButtonGroupProps } from '@mui/material/ToggleButtonGroup';

export const ToggleButtonGroup = ({ ...rest }: ToggleButtonGroupProps) => (
  <MuiToggleButtonGroup {...rest} />
);
